import React from 'react';

const Indemnification: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">User Indemnification</h4>
      <p>You agree to indemnify and hold harmless FeelHeard.me and its officers, directors, employees, and agents from any claims, damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising from:</p>
      
      <ul className="list-disc pl-5 space-y-2">
        <li>Your use of the service</li>
        <li>Violation of these terms</li>
        <li>Content you share</li>
        <li>Interaction with other users</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Defense Rights</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Right to assume exclusive defense</li>
        <li>User cooperation in defense</li>
        <li>Settlement approval rights</li>
        <li>Prompt notification of claims</li>
      </ul>
    </div>
  );
};

export default Indemnification;